export default "__VITE_ASSET__BFnKLNKb__"